import script from "./PermissionsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionsButton.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionsButton.vue?vue&type=style&index=0&id=5128df14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5128df14"]])

export default __exports__